<template>
	<div class="favorites">
		<van-nav-bar :title="title" fixed border>
			<template #left>
				<img src="../../assets/img/icon/left-arrow.png" class="icon" @click="goBack()" />
			</template>
		</van-nav-bar>
		<div class="collapse">
    		<div class="empty" v-if="!loading&&!remindInfo.id"><span class="msg">日程提醒信息丢了！</span></div>

			<van-cell-group :style="{'padding':'10px'}" v-if="remindInfo.id">
				<van-cell :title="contentTitle" >
					<template #label>
						<div v-html="remindInfo.content" :style="{'white-space': 'pre-wrap'}"></div>
					</template>
				</van-cell>
				<van-cell :title="noteTitle" v-if="remindInfo.note">
					<template #label>
						<div v-html="remindInfo.note"></div>
					</template>
				</van-cell>
				<van-cell title="提醒时间">
					<template #label>
						<div>
						{{remindInfo.rdate_beg}}{{remindInfo.rdate_end?('~'+remindInfo.rdate_end):''}} {{remindInfo.stime}}起提醒{{remindInfo.rtimes}}次{{remindInfo.rtimes>1?('（隔'+remindInfo.dtimes+'分钟）'):''}}
						</div>
					</template>
				</van-cell>

				<div v-if="remindInfo.imgs">
					<img :src="attach_url+uri" v-for="(uri,i) in remindInfo.imgs.split(';')" :key="i" :style="{width:'100%','margin':'5px auto'}" @click.stop="previewEnvImg(remindInfo.imgs, i)"/>
				</div>

			</van-cell-group>

		</div>
	</div>
</template>

<style scoped>
</style>

<script type="text/ecmascript-6">
import { ImagePreview } from "vant";
export default {
	name: "message",
	components: {
	},
	data() {
		return {
			title: "日程详情",
			attach_url:this.Conf.serverPre,
			loading:true,
			remindInfo:{},
			contentTitle:'',
			noteTitle:'',
			imgList:[]
		};
	},
	mounted() {
		// 获取浏览器可视区域高度
		this.winH = `${document.documentElement.clientHeight}`;
		window.onresize = function temp() {
			this.winH = `${document.documentElement.clientHeight}`;
		};
	},
	created() {
		var qrys = this.$route.params;
		if(qrys.id && qrys.code){
			this.getStateConfigs();
			this.loadData(qrys.id, qrys.code);
		}else{
			this.loading = false;
		}
	},
	methods: {
		goBack() {
			this.$router.push({ path: "/" });
		},
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
		loadData(id,code) {
			var url = this.Conf.serverUrl + "User/remindInfo/" + id + "/" +code+ "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify({}))
			.then(response => {
				var resp = response.data;
				this.loading = false;
				if(resp.data){
					this.remindInfo = resp.data;
					this.contentTitle = resp.ftypes.cont;
					this.noteTitle = resp.ftypes.note;
				}
			})
			.catch(error => {});
		},
		previewEnvImg(imgs, i){
			imgs = imgs.split(";");
			var imgarr = [];
			for(var ii in imgs){
				imgarr.push(this.attach_url+imgs[ii]);
			}
			ImagePreview({
				images: imgarr,
				startPosition: i,
				showIndex:false,
				showIndicators:true
			});
		}
	},
	watch:{
	}
};
</script>




// WEBPACK FOOTER //
// src/components/My/RemindInfo.vue